__turbopack_context__.v({
  "current": "breadcrumbs-module-scss-module__QeMG-G__current",
  "item": "breadcrumbs-module-scss-module__QeMG-G__item",
  "link": "breadcrumbs-module-scss-module__QeMG-G__link",
  "list": "breadcrumbs-module-scss-module__QeMG-G__list",
  "root": "breadcrumbs-module-scss-module__QeMG-G__root",
  "separator": "breadcrumbs-module-scss-module__QeMG-G__separator",
});
